/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PolicyCategory } from './PolicyCategory';
import {
    PolicyCategoryFromJSON,
    PolicyCategoryFromJSONTyped,
    PolicyCategoryToJSON,
    PolicyCategoryToJSONTyped,
} from './PolicyCategory';

/**
 * 
 * @export
 * @interface CreatePolicyRequest
 */
export interface CreatePolicyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePolicyRequest
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePolicyRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePolicyRequest
     */
    displayText: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePolicyRequest
     */
    isrRequired: boolean;
    /**
     * 
     * @type {PolicyCategory}
     * @memberof CreatePolicyRequest
     */
    category: PolicyCategory;
}



/**
 * Check if a given object implements the CreatePolicyRequest interface.
 */
export function instanceOfCreatePolicyRequest(value: object): value is CreatePolicyRequest {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayText' in value) || value['displayText'] === undefined) return false;
    if (!('isrRequired' in value) || value['isrRequired'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function CreatePolicyRequestFromJSON(json: any): CreatePolicyRequest {
    return CreatePolicyRequestFromJSONTyped(json, false);
}

export function CreatePolicyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePolicyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'displayText': json['displayText'],
        'isrRequired': json['isrRequired'],
        'category': PolicyCategoryFromJSON(json['category']),
    };
}

export function CreatePolicyRequestToJSON(json: any): CreatePolicyRequest {
    return CreatePolicyRequestToJSONTyped(json, false);
}

export function CreatePolicyRequestToJSONTyped(value?: CreatePolicyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'displayText': value['displayText'],
        'isrRequired': value['isrRequired'],
        'category': PolicyCategoryToJSON(value['category']),
    };
}

